// SearchInputController
// Purpose: Triggers a custom event when the search input is cleared (emptied by the user).
// Usage:
//   <input data-controller="search-input" data-action="search->search-input#triggerSearchIfClear">
//
// When the input is cleared, dispatches a 'search:clear' event on the element.

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Connect lifecycle: set up event listeners if needed
  connect() {
    // No setup needed for now
  }

  // Action: Called on 'search' event
  triggerSearchIfClear(event) {
    if (event.target.value !== "") {
      return;
    }

    this.element.closest("form").requestSubmit();
  }
}